import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IntegrationPresetsLoader = _resolveComponent("IntegrationPresetsLoader")!
  const _component_IntegrationConnectionsLoader = _resolveComponent("IntegrationConnectionsLoader")!
  const _component_InstalledIntegration = _resolveComponent("InstalledIntegration")!
  const _component_InstallableIntegration = _resolveComponent("InstallableIntegration")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_IntegrationPresetsLoader, {
      onLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.presets = $event))
    }),
    _createVNode(_component_IntegrationConnectionsLoader, {
      "account-id": _ctx.accountId,
      onLoaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connections = $event))
    }, null, 8, ["account-id"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installed, (integration) => {
      return (_openBlock(), _createBlock(_component_InstalledIntegration, {
        key: integration.id,
        preset: integration.preset,
        connection: integration.connection,
        class: "shadow-1 q-my-md",
        "onUpdate:connection": _ctx.update
      }, null, 8, ["preset", "connection", "onUpdate:connection"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installablePresets, (preset) => {
      return (_openBlock(), _createBlock(_component_InstallableIntegration, {
        key: preset.type,
        "account-id": _ctx.accountId,
        preset: preset,
        class: "shadow-1 q-my-md",
        onInstalled: _cache[2] || (_cache[2] = ($event: any) => (_ctx.connections.push($event)))
      }, null, 8, ["account-id", "preset"]))
    }), 128))
  ]))
}